import type React from 'react'

export type TCardSelecaoSimulacaoWrapperProps = {
  isMobile: boolean
  isSelectable: boolean
  selected: boolean
  onToggle: () => void
  children: React.ReactNode
}

export function CardSelecaoSimulacaoWrapper({
  isMobile,
  isSelectable,
  selected,
  onToggle,
  children,
}: Readonly<TCardSelecaoSimulacaoWrapperProps>) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onToggle()
    }
  }

  if (isMobile && isSelectable) {
    return (
      <button
        type="button"
        onClick={onToggle}
        onKeyDown={handleKeyDown}
        aria-pressed={selected}
        data-state={selected ? 'checked' : 'unchecked'}
        className="shadow-cz w-full overflow-hidden rounded-md text-left transition-colors data-[state='checked']:border data-[state='checked']:border-slate-400"
      >
        {children}
      </button>
    )
  }

  return (
    <div
      data-state={selected ? 'checked' : 'unchecked'}
      className="shadow-cz overflow-hidden rounded-md transition-colors data-[state='checked']:border data-[state='checked']:border-slate-400"
    >
      {children}
    </div>
  )
}
